import { useFormik } from 'formik'
import React, { useEffect, useState, useTransition } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import * as Yup from "yup"
import useWindowSize from '../../utils/useWindowSize'
import { SectorsEn, SectorsTr } from '../../redux/types'

interface FilterModalProps {
    isOpen: boolean
    handleClose: () => void
    setFilterOptions: (opts: any) => void
    resetFilterOptions: () => void
    filterOptions: any
}

export default function FilterModal(props: FilterModalProps) {


    const [width_] = useWindowSize()

    const { i18n, t } = useTranslation()

    const [filterOptions, setFilterOptions] = useState({
        sector: "",
    })

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: filterOptions,
        validationSchema: Yup.object({
            sector: Yup.string(),

        }),
        onSubmit: values => {
            setFilterOptions({
                sector: values.sector,

            })
            props.handleClose()
        }
    })



    useEffect(() => {
        props.setFilterOptions(filterOptions)
    }, [filterOptions])

    useEffect(() => {
        if (props.filterOptions.sector !== filterOptions.sector)
            setFilterOptions(props.filterOptions)
    }, [props.filterOptions])

    const handleReset = () => {
        setFilterOptions({
            sector: "",


        })
        props.handleClose()
    }

    return (
        <Modal centered isOpen={props.isOpen}>
            <ModalHeader toggle={props.handleClose}>{i18n.language === "tr" ? "Filtrele" : "Filter"}</ModalHeader>
            <ModalBody>
                <Form onSubmit={e => {
                    validation.handleSubmit()
                    e.preventDefault()


                    return false
                }}
                    action='#'
                >
                    <label className='ms-1 mt-2 mb-2'>{i18n.language === "tr" ? "Sektör" : "Sectors"}</label>
                    <Input
                        name='sector'
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sector || ""}
                        type='select'
                        defaultValue={filterOptions.sector}
                    >
                        <option value="" hidden>{i18n.language === "tr" ? "Sektör seçin" : "Select"}</option>
                        {Object.values(i18n.language === "tr" ? SectorsTr : SectorsEn).map((item, i) => {

                            return (
                                <option key={i}>{item}</option>
                            )
                        })}
                    </Input>

                    <div className='d-flex' style={{ justifyContent: "end", marginTop: "20px" }}>
                        <Button className='me-2 ' color='danger' onClick={handleReset}>{i18n.language === "tr" ? "Sıfırla" : "Reset"}</Button>
                        <Button type='submit' color='info' >{i18n.language === "tr" ? "Filtrele" : "Filter"}</Button>
                    </div>
                </Form>
            </ModalBody>

        </Modal>
    )
}
